import axios from "axios";

export const ERR_FREE_SITES_LIMIT_REACHED = "FREE_SITES_LIMIT_REACHED";

/**
 * Checks whether an unknown error thrown from an api/index.ts call is an
 * AxiosError carrying the given backend error `code` in its response body.
 */
export const isApiError = (e: unknown, code: string): boolean => {
  return axios.isAxiosError(e) && e.response?.data?.code === code;
};
